import { Icon } from '@iconify/react';
import * as React from 'react';

interface IIconifyIconProps {
  size?: number;
  name: string;
  color?: string;
  className?: string;
}

const IconifyIcon: React.FunctionComponent<IIconifyIconProps> = ({
  size = 20,
  color = 'white',
  name,
  className,
}) => {
  return <Icon className={className} icon={name} width={size} height={size} color={color} />;
};

export default IconifyIcon;
